<template>
  <v-dialog 
    v-model="dialog" 
    width="600" 
    content-class="simpleDialog"
  >
    <v-card class="pa-10" @click="dialog = false">
      <div v-for="content in contents">{{ content }}</div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      contents: []
    }
  },
  created() {
    this.$root.$on('simpleDialog', this.open)
  },
  beforeDestroy() {
    this.$root.$off('simpleDialog', this.open)
  },
  methods: {
    open(contents) {
      this.dialog = true
      this.contents = contents
    }
  }
}
</script>

<style lang="scss" scoped>
.simpleDialog {
  p {
    color: $grey-4 !important;
  }
}
</style>